<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        文物单位消防安全检查登记表
      </div>
    </div>
    <!-- <unitList @select="getUnit" @getFirst='getOne'></unitList> -->
    <el-form ref="form" :model="form" label-width="110px" :rules="rules" class="mt20">
      <div class="f-right border-b">
        <div class="flex1">基本信息</div>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            label-width="160px"
            prop="c_company_num"
            label="单位名称或建筑名称"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
          >
            <el-select v-model="form.c_company_num" filterable>
              <el-option v-for="item in shangjioption" :key="item.value" :label="item.key" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="单位地址">
            <el-input v-model="form.base.ww_address"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label-width="150px" label="文物所属监督机构">
            <el-input v-model="form.base.ww_father"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="建筑产权单位">
            <el-input v-model="form.base.ww_chanquan"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="200px" label="消防单位安全责任人或业主">
            <!-- <v-select :value.sync="form.base.c_type" :id="1"></v-select> -->
            <el-input type="text" v-model="form.base.ww_zeren"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="责任人联系电话">
            <el-input type="text" v-model="form.base.ww_zeren_phone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="200px" label="消防单位安全管理人或业主">
            <el-input type="text" v-model="form.base.ww_guanli"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="管理人联系电话">
            <el-input type="text" v-model="form.base.ww_guanli_phone"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="占地面积">
            <el-input type="text" v-model="form.base.ww_area"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            prop="company_type"
            label="行业编码"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
          >
            <v-select :value.sync="form.company_type" :id="66"></v-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="人数">
            <el-input type="text" v-model="form.base.ww_peoplenum"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="营业执照号码">
            <el-input type="text" v-model="form.base.ww_yyzznum"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            prop="company_area"
            label="地区"
            :rules="{
              message: '请填写/选择',
              trigger: 'change',
              required: true,
            }"
          >
            <el-cascader
              :options="area"
              v-model="areaValue"
              @change="areaChange"
              :props="{
                value: 'area_name',
                label: 'area_name',
                children: 'childArea',
              }"
            >
              <template slot-scope="{ node, data }">
                <span>{{ data.area_name }}</span>
              </template>
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label-width="140px" label="消防安全重点单位">
            <el-radio-group v-model="form.base.ww_import_company">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="7">
          <el-form-item label="检查单位">
            <el-input type="text" v-model="form.base.ww_checkcomp"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="检查时间">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.base.ww_in_net" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="被检查单位">
            <el-input type="text" v-model="form.base.ww_bjcunit"></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="检查的内容">
            <el-input type="textarea" v-model="form.base.ww_content"></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="发现的问题及隐患" label-width="150px">
            <el-input type="textarea" v-model="form.base.ww_problem"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="f-right border-b">
        <div class="flex1">消防设施</div>
      </div>

      <el-checkbox-group class="mt20" v-model="form.build_xfss">
        <el-row :gutter="50" class="flex">
          <el-form-item v-for="(item, index) in buildList" :key="index">
            <el-col :span="5">
              <el-checkbox v-for="(items, idx) in item" :key="idx" :label="items.key">{{ items.value }}</el-checkbox>
            </el-col>
          </el-form-item>
          <el-col :span="5" class="flex">
            <el-checkbox :label="true">其它设施：</el-checkbox>
            <el-input size="mini" v-model="form.base.ww_other"></el-input>
          </el-col>
        </el-row>
      </el-checkbox-group>
      <!-- <div v-for="(item,index1) in tabList" >
            <div class="btn-box">
                <div class="btn" @click="addList(index1,0)"><i class="icon-tr-newly-added"></i>新增</div>
            </div>
            <table class="common-table mt20">
                <thead>
                <tr>
                    <th v-for="data in item.data">
                        {{data.text}}
                    </th>
                    <th>
                        操作
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in form[tabList[0].form]">
                    <td class="common-add" v-for="(input,key,index2) in tabList[0].data">
                        <el-input placeholder="请输入" v-model="form[tabList[0].form][index][input.form_name]"
                                  v-if="input.type=='text'"></el-input>
                        <div v-if="input.type=='select'">
                            <v-select :value.sync="form[tabList[0].form][index][input.form_name]"
                                      :id="input.op_id||input.option"></v-select>
                        </div>
                        <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                                        v-model="form[tabList[0].form][index][input.form_name]"
                                        v-if="input.type=='date'"></el-date-picker>
                    </td>
                    <td class="td-btn">
                        <a class="clear-data" @click="del(index)">
                            <i class="icon-tr-delete"></i>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div> -->
      <div class="mt20" v-for="(item, index1) in tabList">
        <div class="f-right border-b">
          <div class="flex1">{{ item.title }}</div>
          <div class="btn-box">
            <div class="btn" @click="addList(index1)"><i class="icon-tr-newly-added"></i>新增</div>
          </div>
        </div>

        <table class="common-table ml20 mt10">
          <thead>
            <tr>
              <th v-for="data in item.data">
                {{ data.text }}
              </th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in form[tabList[index1].form]">
              <td class="common-add" v-for="(input, key, index2) in tabList[index1].data">
                <el-input placeholder="请输入" v-model="form[tabList[index1].form][index][input.form_name]" v-if="input.type == 'text'"></el-input>
                <div v-if="input.type == 'select'">
                  <v-select :value.sync="form[tabList[index1].form][index][input.form_name]" :id="input.op_id || input.option"></v-select>
                </div>
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  v-model="form[tabList[index1].form][index][input.form_name]"
                  v-if="input.type == 'date'"
                ></el-date-picker>
              </td>
              <td class="td-btn">
                <a class="clear-data" @click="del(index1, index)">
                  <i class="icon-tr-delete"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-form>

    <div class="btn-box">
      <div class="l-btn" @click="onSubmit">保存</div>
      <div class="l-btn ml20" @click="$router.back()">返回</div>
    </div>
  </div>
</template>

<script>
import { buildList } from "./options";
import { addCompany, editCompany } from "../../api/company";
import { getArea } from "../../api/common";

export default {
  data() {
    return {
      area: [],
      areaValue: ["山东省", "青岛市", "市南区"],
      shangjioption: [],
      buildList: buildList,
      form: {
        w_uuid: "",
        c_company_num: "",
        company_type: "",
        company_area: ["山东省", "青岛市", "市南区"],
        base: {
          ww_name: "", // 单位名称或建筑名称
          ww_address: "", // 单位地址
          ww_father: "", // 文物所属监督机构
          ww_chanquan: "", // 产权单位
          ww_zeren: "", // 责任人
          ww_zeren_phone: "", // 责任人电话
          ww_guanli: "", // 管理人
          ww_guanli_phone: "", // 管理人电话
          ww_area: "", //占地面积
          ww_peoplenum: "", //人数
          ww_yyzznum: "", // 营业执照号码
          ww_import_company: "", //消防安全重点单位
          ww_checkcomp: "", //检查单位
          ww_in_net: "", // 检查时间
          ww_other: "", //其他设施
          ww_bjcunit: "", //被检查单位
          ww_content: "", // 检查内容
          ww_problem: "", //检查问题
        },
        build_xfss: [], //消防设施
        single_build: [], // 单体建筑
        using_build: [], //场所入住使用建筑情况
      },
      tabList: [
        {
          title: "单体建筑",
          form: "single_build",
          data: [
            { form_name: "ww_sinname", type: "text", text: "单体建筑名称" },
            { form_name: "ww_singheight", type: "text", text: "建筑高度" },
            { form_name: "ww_singarea", type: "text", text: "面积" },
            { form_name: "ww_singup", type: "text", text: "地上层数" },
            { form_name: "ww_sinddown", type: "text", text: "地下层数" },
            {
              form_name: "ww_singnum",
              type: "text",
              text: "消防验收、备案、合格证号",
            },
            // {form_name: 'cb_yinqing', type: 'text', text: '火灾引擎'},
          ],
        },
        {
          title: "场所入住使用建筑",
          form: "using_build",
          data: [
            {
              form_name: "ww_usename",
              type: "text",
              text: "场所入住使用建筑情况",
            },
            { form_name: "ww_useheight", type: "text", text: "使用建筑面积" },
            { form_name: "ww_useup", type: "text", text: "地上层数" },
            { form_name: "ww_usedown", type: "text", text: "地下层数" },

            // {form_name: 'cb_yinqing', type: 'text', text: '火灾引擎'},
          ],
        },
      ],
      rules: {},

      allAreaList: [],
      cityList: [],
      areaList: [],
    };
  },
  created() {
    this.$get("/trxf/main/sys/area/arealist").then((res) => {
      this.area = res.data;
      this.area.forEach((a) => {
        a.childArea.forEach((b) => {
          //log(b.childArea)
          b.childArea.forEach((c) => {
            if (!c.childArea.length) {
              c.childArea = null;
            }
          });
        });
      });
    });
    this.$post("/trxf/main/xf/danwei/xfdanweixinxi/querybasemapwenwu").then((res) => {
      var arr = [];
      res.data.map((item, index) => {
        arr.push({ key: item.c_name, value: item.c_company_num });
      });
      this.shangjioption = arr;
    });
    if (this.$route.query.id) {
      this.$post("checklist/seruritytablefindone", {
        w_uuid: this.$route.query.id,
      }).then((res) => {
        var data = JSON.parse(res.data[0].company_json);
        data.w_uuid = res.data[0].w_uuid;
        //  var {from:{get_build},from} = res
        //  if(get_build.length){
        //      get_build.map((item,index)=>{
        //          item.old_name = item.cb_name
        //      })
        //  }
        //  console.log(res.from)
        // this.form = res.from
        // this.$set(this,'areaValue',[res.from.base.c_province,res.from.base.c_city,res.from.base.c_area])
        // //this.areaValue = [res.from.base.c_province,res.from.base.c_city,res.from.base.c_area]
        this.form = data;
        this.$set(this, "areaValue", data.company_area);
      });
    }
  },
  mounted() {},

  methods: {
    areaChange(val) {
      log(val);
      this.form.company_area = val;
    },
    getLoa(val) {
      this.form.base.lon = String(val[0]);
      this.form.base.lat = String(val[1]);
    },
    proChanege(flag) {
      this.cityList = [];
      this.areaList = [];
      flag !== 1 && (this.form.base.c_city = "");
      flag !== 1 && (this.form.base.c_area = "");
      this.allAreaList.forEach((it) => {
        if (it.area_code == this.form.base.c_province) {
          this.cityList = it.city;
        }
      });
    },
    cityChanege(flag) {
      this.areaList = [];
      !flag && (this.form.base.c_area = "");
      this.cityList.forEach((it) => {
        if (it.area_code == this.form.base.c_city) {
          this.areaList = it.get_area;
        }
      });
    },
    addList(index) {
      let obj = {};
      this.tabList[index].data.forEach((it) => {
        obj[it.form_name] = "";
      });
      this.form[this.tabList[index].form].push(obj);
    },
    del(index, index2) {
      this.form[this.tabList[index].form].splice(index2, 1);
    },

    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.save();
        } else {
          return false;
        }
      });
    },
    save() {
      // int.forEach(it => {
      //     if (this.form.base[it]) {
      //         this.form.base[it] = +this.form.base[it]
      //     }
      //     for (var key in this.form) {
      //         if (key != 'base') {
      //             this.form[key].forEach(im => {
      //                 if (im[it] !== '') {
      //                     im[it] = +im[it]
      //                 }
      //             })
      //         }
      //     }
      // })

      // console.log(this.form.get_build)

      // console.log('处理逻辑')

      if (!this.$route.query.id) {
        // addCompany(this.form).then(res => {
        //     if (res.code < 1000) {
        //         this.$message.success('保存成功')
        //         this.$router.back()
        //     }
        //     logading.close()
        // }).catch(res => {
        //     logading.close()
        // })
        this.$post("checklist/seruritytableadd", this.form).then((res) => {
          if (res.code < 1000) {
            this.$message({message: res.msg,type: "success", duration: 700,});
            this.$router.back();
          }
        });
      } else {
        // editCompany(this.form).then(res => {
        //     if (res.code < 1000) {
        //         this.$message.success('保存成功')
        //         this.$router.back()
        //     }
        //     logading.close()
        // }).catch(res => {
        //     console.log(res.code)
        //     logading.close()
        // })
        this.$post("checklist/seruritytableupdate", this.form)
          .then((res) => {
            if (res.code < 1000) {
              this.$message({message: res.msg,type: "success", duration: 700,});
              this.$router.back();
            }
          })
          .catch((res) => {});
      }
    },
  },
};
</script>

<style scoped>
.container-list {
  padding: 0 20px;
}
</style>
